import MainImage from '../voluntary-template/icons/VoluntaryTransport.png';
import VectorFirst from '../voluntary-template/icons/box/shield.svg';
import VectirSecond from '../voluntary-template/icons/box/clinical_notes.svg';
import VectorThird from '../voluntary-template/icons/box/fact_check.svg';
import Checkbox from '../voluntary-template/icons/Checkbox.svg';
import Thunder from '../voluntary-template/icons/Thunder.svg';
import Contract from '../voluntary-template/icons/VoluntaryCarGPO.png';
import Shield from '../voluntary-template/icons/Shield.png';
import Star from '../voluntary-template/icons/Star.png';
import Pyramid from '../voluntary-template/icons/pyramid.png';
import People from '../voluntary-template/icons/people.png';
import Box from '../voluntary-template/icons/Box.png';

const voluntaryTransportResources = {
  en: {
    voluntaryTransport: {
      title: 'Vehicle Insurance',
      description:
        'CASCO is a voluntary insurance that provides full financial protection for your vehicle. We cover risks such as theft, damage, traffic accidents, and other unforeseen situations.',
      buttonText: 'Submit Application',
      infoCards: [
        {
          title: 'Protection from All Risks',
          content:
            'CASCO covers everything from minor damage to total loss or theft of the vehicle.',
        },
        {
          title: 'Convenient Claims Handling',
          content:
            'Authorized service centers, repairs at market value, without delays.',
        },
        {
          title: 'Suitable for New and Used Cars',
          content:
            'Flexible programs — from basic coverage to extended plans with depreciation included.',
        },
      ],
      coverage: [
        {
          title: 'What We Insure',
          content: [
            'Passenger vehicles',
            'Trucks and commercial vehicles',
            'Vehicles owned by individuals and legal entities',
          ],
        },
        {
          title: 'Covered Risks',
          content: [
            'Theft or attempted theft',
            'Damage caused by a traffic accident',
            'Natural disasters, fire, falling objects',
            'Unlawful actions by third parties',
          ],
        },
        {
          title: 'Illustration',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Insurance Amount',
          content:
            'Determined based on the market or contractual value of the vehicle.',
        },
        {
          title: 'Duration',
          content: '1 year. Extension possible.',
        },
        {
          title: 'Coverage Area',
          content:
            'Throughout the Republic of Kazakhstan. Upon request — coverage extension for trips abroad.',
        },
      ],
      formTitle: 'Insurance Application',
      formDescription:
        'Please be sure to provide the company name, BIN, and contact phone number.',
      formCheckBox1: 'I confirm',
      formCheckBox2:
        'my consent to the collection and processing of personal data',
      formPlaceholder1: 'Company',
      formPlaceholder2: 'BIN',
      formPlaceholder3: 'Full Name',
      formPlaceholder4: 'Phone',
      formPlaceholder5: 'Email',
      formPlaceholder6: 'Comment',
      formButtonText: 'Submit Application',
      formSuccessStatus: 'Your application has been submitted successfully.',
      formErrorStatus: 'Failed to submit the application.',
      formErrorMessage:
        'Please try submitting the application again in 4 hours.',
      formSendClose: 'Close',
      trustTitle: 'Why clients trust Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 years',
            content: 'on the insurance market of Kazakhstan',
          },
          {
            id: 2,
            title: 'TOP 2',
            content: 'by volume of insurance payouts',
          },
          {
            id: 3,
            title: 'kzA-',
            content: 'financial stability rating by S&P Global Ratings',
          },
          {
            id: 4,
            title: '600+',
            content: 'employees working across the country',
          },
        ],
        second: [
          {
            id: 5,
            title: '₸59.4 billion',
            content: 'insurance premiums collected in 2024',
          },
          {
            id: 6,
            title: '₸22 billion',
            content: 'insurance payouts made in 2024',
          },
        ],
        third: '(According to the National Bank of Kazakhstan, Jan–Feb 2025)',
      },
    },
  },
  kz: {
    voluntaryTransport: {
      title: 'КАСКО автокөлігін сақтандыру',
      description:
        'Сіздің көлігіңізді ұрлау, зақымдау, ЖКО және басқа да күтпеген оқиғалардан зақымдану, опат болу немесе жоғалту жағдайларынан толық қаржылық қорғауды қамтамасыз ететін автомобиль көлігін ерікті сақтандыру.',
      buttonText: 'Өтініш беру',
      infoCards: [
        {
          title: 'Сақтандыру не үшін қажет',
          content:
            'Көлік құралының иесінің мүдделерін қорғайды, тіпті егер ол өзі ЖКО-ға кінәлі болса да.',
        },
        {
          title: 'Дербес талаптар',
          content:
            'Сақтандыру талаптары қызмет түріне, көлік құралының маркасына, моделіне және шығарылған жылына байланысты әрбір клиент бойынша дербес белгіленеді.',
        },
        {
          title: 'Ыңғайлы есеп айырысу',
          content:
            'Төлемдер мамандандырылған ТҚС-тың шоты бойынша да, тәуелсіз сарапшының залалды бағалауы негізінде де жүргізілуі мүмкін.',
        },
      ],
      coverage: [
        {
          title: 'Нені сақтандырамыз',
          content: [
            'Жеңіл автомобильдер',
            'Жүк тиейтін және коммерциялық көлік құралдары',
            'Мамандандырылған техника',
            'Тіркемелер мен жартылай тіркемелер',
          ],
        },
        {
          title: 'Қандай тәуекелдерден',
          description:
            'Төмендегілердің салдарынан көлік құралының зақымдалуы, жойылуы немесе жоғалуы:',
          content: [
            'ЖКО салдарынан зақымдану',
            'Табиғи апат, өрт',
            'Бөтен заттардың құлауы',
            'Үшінші тұлғалардың құқыққа қарсы іс-қимылдары, айдап әкету, ұрлау',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Сақтандыру сомасы',
          content:
            'Көлік құралының нарықтық немесе кепілдік құны негізінде анықталады.',
        },
        {
          title: 'Қолданыс мерзімі',
          content: '12 ай.',
        },
        {
          title: 'Сақтандыру аумағы',
          content:
            'Қазақстан Республикасы. Сұраныс бойынша - Ресей Федерациясы мен ТМД елдері бойынша қамтуды кеңейтуге болады.',
        },
      ],
      formTitle: 'Өтінім қалдыру',
      formDescription: 'БСН және байланыс телефонын көрсетуді ұмытпаңыз.',
      formCheckBox1: 'Мен',
      formCheckBox2:
        'жеке деректерімді жинауға және өңдеуге келісімімді растаймын',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БСН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.пошта',
      formPlaceholder6: 'Түсініктеме',
      formButtonText: 'Жөнелту',
      formSuccessStatus: 'Сіздің өтінішіңіз сәтті жіберілді.',
      formErrorStatus: 'Өтінішті жіберу сәтсіз аяқталды.',
      formErrorMessage: 'Өтінішті 4 сағаттан кейін жіберіп көріңіз.',
      formSendClose: 'Жабу',
      trustTitle: 'Неліктен клиенттер Alatau City Garant-қа сенім артады',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 жыл',
            content: 'Қазақстанның сақтандыру нарығында қызмет еткеніне',
          },
          {
            id: 2,
            title: '3 орын',
            content:
              '2024 жылы ҚР жалпы сақтандыру компаниялары арасында сақтандыру төлемдерінің көлемі бойынша',
          },
          {
            id: 3,
            title: 'ВВ-Болжам «Тұрақты»',
            content: 'S&P Global Ratings қаржылық тұрақтылық рейтингі',
          },
          {
            id: 4,
            title: '22 филиал',
            content: 'Alatau City Garant бүкіл ел аумағында жұмыс істейді',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content:
              'сақтандыру сыйлықақыларын Alatau City Garant 2024 жылы жинады',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'Alatau City Garant 2024 жылы клиенттерге төледі',
          },
        ],
        third: '(ҚР Ұлттық Банкінің деректері бойынша)',
      },
      businessDescription:
        'КАСКО — бұл сіздің көлігіңізге толық қаржылық қорғаныс беретін ерікті сақтандыру.',
    },
  },
  ru: {
    voluntaryTransport: {
      title: 'Cтрахование автотранспорта КАСКО',
      description:
        'Добровольное страхование автомобильного транспорта, обеспечивающее полную финансовую  защиту вашего автомобиля от случаев повреждения, гибели  или утраты в результате угона, повреждений, ДТП и других непредвиденных событий.',
      buttonText: 'Отправить заявку',
      infoCards: [
        {
          title: 'Для чего нужна страховка',
          content:
            'Защищает интересы владельца транспортного средства, даже если он сам станет виновником ДТП.',
        },
        {
          title: 'Персональные условия',
          content:
            'Условия страхования устанавливаются по каждому клиенту индивидуально, в зависимоти от вида деятельности, марки модели и года выпуска транспортного средства.',
        },
        {
          title: 'Удобное урегулирование',
          content:
            'Выплаты могут производиться как по счету Специализированного СТО, так и на основании оценки ущерба независимого эксперта.',
        },
      ],
      coverage: [
        {
          title: 'Что страхуем',
          content: [
            'Легковые автомобили',
            'Грузовые и коммерческие транспортные средства',
            'Специализированную технику',
            'Прицепы и полуприцепы',
          ],
        },
        {
          title: 'Покрываемые риски',
          description:
            'Повреждение, гибель или утрата транспортного средства в результате:',
          content: [
            'Повреждения в результате ДТП',
            'Стихийного бедствия, пожар',
            'Падение инородных предметов',
            'Противоправных действий третьих лиц, угона, кражи',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Страховая сумма',
          content:
            'Определяется на основе рыночной или залоговой стоимости транспортного средства.',
        },
        {
          title: 'Срок действия',
          content: '12 месяцев.',
        },
        {
          title: 'Территория страхования',
          content:
            'Республики Казахстан. По запросу — возможно расширение покрытия по Росийской Федерации и странам СНГ.',
        },
      ],
      formTitle: 'Заявка на страхование',
      formDescription:
        'Пожалуйста, обязательно укажите БИН и контактный телефон.',
      formCheckBox1: 'Я подтверждаю ',
      formCheckBox2: 'согласие на сбор и обработку персональных данных',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БИН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.почта',
      formPlaceholder6: 'Комментарий',
      formButtonText: 'Отправить заявку',
      formSuccessStatus: 'Спасибо! Ваша заявка отправлена',
      formErrorStatus: 'Не удалось отправить заявку',
      formErrorMessage: 'Попробуйте отправить заявку через 4 часа.',
      formSendClose: 'Закрыть',
      trustTitle: 'Почему клиенты доверяют Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 лет',
            content: 'на страховом рынке Казахстана',
          },
          {
            id: 2,
            title: '3 место',
            content:
              'по объему страховых выплат среди компаний общего страхования РК в 2024 году',
          },
          {
            id: 3,
            title: 'ВВ-прогноз «Стабильный»',
            content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
          },
          {
            id: 4,
            title: '22 филиала',
            content: 'Alatau City Garant работают по всей стране ',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content: 'страховых премий собрал Alatau City Garant в 2024 году',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'выплатил Alatau City Garant клиентам в 2024 году ',
          },
        ],
        third: '(по данным Нацбанка РК)',
      },
      businessDescription:
        'КАСКО — это добровольное страхование, обеспечивающее полную финансовую защиту вашего автомобиля.',
    },
  },
  mainCard: {
    image: MainImage,
  },
  infoCards: [
    {
      id: 1,
      image: VectorFirst,
    },
    {
      id: 2,
      image: VectirSecond,
    },
    {
      id: 3,
      image: VectorThird,
    },
  ],
  coverage: [
    {
      title: 'Что страхуем?',
      content: [
        'Легковые автомобили',
        'Грузовые и коммерческие транспортные средства',
        'Специализированную технику',
        'Прицепы и полуприцепы',
      ],
      image: Checkbox,
    },
    {
      title: 'Покрываемые риски',
      description:
        'Повреждение, гибель или утрата транспортного средства в результате:',
      content: [
        'Повреждения в результате ДТП',
        'Стихийного бедствия, пожар',
        'Падение инородных предметов',
        'Противоправных действий третьих лиц, угона, кражи',
      ],
      image: Thunder,
    },
    {
      title: 'Иллюстрация',
      content: [],
      image: Contract,
    },
  ],
  featureCards: [
    {
      title: 'Страховая сумма',
      content:
        'Определяется на основе рыночной или договорной стоимости транспортного средства.',
    },
    {
      title: 'Срок действия',
      content: '1 год. Возможна пролонгация.',
    },
    {
      title: 'Территория действия',
      content:
        'Вся территория Республики Казахстан. По запросу — расширение покрытия на поездки за рубеж.',
    },
  ],
  trustCards: {
    first: [
      {
        id: 1,
        title: '17 лет',
        content: 'на страховом рынке Казахстана',
        image: Shield,
      },
      {
        id: 2,
        title: 'ТОП 2',
        content: 'по объёму страховых выплат ',
        image: Star,
      },
      {
        id: 3,
        title: 'kzA-',
        content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
        image: Pyramid,
      },
      {
        id: 4,
        title: '600+',
        content: 'сотрудников работают по всей стране',
        image: People,
      },
    ],
    second: [
      {
        title: '59,4 млрд ₸',
        content: 'страховых премий собрано за 2024 год ',
      },
      {
        title: '22 млрд ₸',
        content: 'выплачено по страховым случаям за 2024 год',
      },
    ],
    image: Box,
  },
};

export default voluntaryTransportResources;
